import { getLastCertificationReservationConditions } from '@lp/features/AssignmentTables/utils';
import {
  ConflictedReservation,
  ConflictedRest,
  EmployeeAssignmentCandidateMatch,
  LastCertificationsAtHubInfo,
} from '@/api/apis/resources';
import { getReservationConditions, getShiftTimeGroupCondition, miss } from './utils';
import { ConflictReservationInfo } from './ConflictReservationInfo';
import { CSShiftTimeGroup, Unavailability } from '@/api/apis/resources/schedule';

type ReservationConditionProps = {
  orTime?: string;
  applyGoTime?: boolean;
  conflictReservation?: ConflictedReservation;
  conflictRest?: ConflictedRest;
  match: EmployeeAssignmentCandidateMatch;
  onCallAfterTargetMinutes?: number | null;
  onCallBeforeTargetMinutes?: number | null;
  onRestEndsBeforeTargetMinutes?: number | null;
  onRestStartsAfterTargetMinutes?: number | null;
  unavailabilities?: Unavailability[];
  caseName?: string;
  lastCertificationAtHubInfo?: LastCertificationsAtHubInfo;
  shiftTimeGroup?: CSShiftTimeGroup | null;
};

export const ReservationCondition = ({
  orTime,
  applyGoTime,
  conflictReservation,
  conflictRest,
  match,
  onCallAfterTargetMinutes,
  onCallBeforeTargetMinutes,
  onRestEndsBeforeTargetMinutes,
  onRestStartsAfterTargetMinutes,
  unavailabilities,
  caseName,
  lastCertificationAtHubInfo,
  shiftTimeGroup,
}: ReservationConditionProps) => {
  const conditions = getReservationConditions(
    match,
    onCallBeforeTargetMinutes,
    onCallAfterTargetMinutes,
    onRestStartsAfterTargetMinutes,
    onRestEndsBeforeTargetMinutes,
    unavailabilities,
    orTime,
    applyGoTime,
  );
  const shiftTimeGroupCondition = getShiftTimeGroupCondition(shiftTimeGroup);
  const certificatesConditions = getLastCertificationReservationConditions({ lastCertificationAtHubInfo });
  const hasConflictedRest = miss(match.onRestMatchType) && !!conflictRest;

  return (
    <div className="flex flex-col text-s-m">
      {hasConflictedRest && (
        <div className="flex gap-2">
          <span className="text-danger-20">On Rest</span>
          <span>{conflictRest.caseName}</span>
        </div>
      )}
      <ConflictReservationInfo reservation={conflictReservation} caseTypeMatch={match.caseType} caseName={caseName} />
      <div className="text-s-r whitespace-pre-line">
        {[...shiftTimeGroupCondition, ...conditions, ...certificatesConditions].join('\n')}
      </div>
    </div>
  );
};
